import React, { FC, useCallback } from 'react';
import ReactModal from 'react-modal';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { closeModal, ModalState } from '../../redux/modal';

if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'test') {
  ReactModal.setAppElement('.root-element');
}

export interface ModalProps extends Omit<ModalState, 'label'> {
  contentLabel: ModalState['label'];
  shouldCloseOnEsc?: boolean;
}

const mapStateToProps = ({
  modal,
}: {
  modal: ModalState;
}): Omit<ModalProps, 'closeModal'> => ({
  ...modal,
  contentLabel: modal.label,
  shouldCloseOnEsc: modal.closeOnEscape || false,
});

const Modal: FC = () => {
  const dispatch = useDispatch();
  const { content, isOpen, contentLabel, ...state } = useSelector(
    mapStateToProps,
    shallowEqual
  );
  const onRequestClose = useCallback(() => dispatch(closeModal()), [dispatch]);
  return (
    <ReactModal
      overlayClassName="fixed top-0 right-0 left-0 bottom-0 z-2 overflow-y-auto bg-black-80"
      className="relative w-100 h-100 flex flex-column items-center justify-center"
      bodyOpenClassName="overflow-hidden"
      onRequestClose={onRequestClose}
      isOpen={!!isOpen}
      // @ts-expect-error seems to legitimately accept react elements though not typed as such
      contentLabel={contentLabel}
      {...state}
    >
      {content}
    </ReactModal>
  );
};

export default Modal;
